import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-functions-once',
  slug: 'once',
  title: 'Run it only once',
  type: 'code',
  estSeconds: 420,
  contentVersion: 1,
});
